import { message, Modal } from 'antd';
import React, { useState } from 'react';
import { deleteFolder, folderList } from '../../../../services/file';

import './index.scss';
import useFolderStore from '../../../../stores/folderStore';
import { t } from '../../../../locales';

type Props = {
  folderId: number,
  folderName: string,
  onSuccess?: () => void,
  onCancel?: () => void,
}

const DeleteFolder = (props: Props) => {
  const { folderId, folderName, onSuccess, onCancel } = props;
  const [deleteModalVisible, setDeleteModalVisible] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const { setFolders } = useFolderStore.getState();

  const handleDeleteCancel = () => {
    setDeleteModalVisible(false);
    onCancel?.();
  }

  const handleDeleteSubmit = async () => {
    setDeleteLoading(true);
    try {
      // 调用删除接口
      await deleteFolder(folderId);

      message.success(t('common.deleteSuccess'));
      setDeleteModalVisible(false);

      // 调用成功回调
      onSuccess?.();
      const res = await folderList()
      setFolders(res.folders)

    } catch (error) {
      message.success(t('common.deleteFail'));
    } finally {
      setDeleteLoading(false);
    }
  }

  return (
    <Modal
      title={t('common.info')}
      visible={deleteModalVisible}
      onCancel={handleDeleteCancel}
      onOk={handleDeleteSubmit}
      confirmLoading={deleteLoading}
      okText={t('common.delete')}
      cancelText={t('common.cancel')}
      destroyOnClose
      maskClosable={false}
      width={460}
      className="rename-modal"
      okButtonProps={{ danger: true }}
    >
      <div className="rename-input-container">
        {t('file.deleteFolderTips')}
      </div>
    </Modal>
  )

}

export default DeleteFolder;
